import { useCallback, useLayoutEffect, useRef, useState } from 'react';
import { useFormContext } from '../../Form';
import { axiosGeonamesClient } from 'Api';

export function useRegionProviderController() {
  const [loading, setLoading] = useState<Record<string, boolean>>({});
  const form = useFormContext();
  const countriesByKey = useRef<
    Record<string, { label: string; value: string }[]>
  >({});
  const [countries, setCountries] =
    useState<{ label: string; value: string }[]>();

  useLayoutEffect(() => {
    loadCountries?.('en');
    const cb = () => {
      if (form.language?.key) {
        loadCountries?.(form.language?.key);
      } else {
        loadCountries?.('en');
      }
    };
    if (form?.language?.key && form?.language?.key !== 'en') {
      loadCountries?.(form?.language?.key);
    }
    form?.subscribe?.('language', cb);
    return () => {
      form?.unsubscribe?.('language', cb);
    };
  }, []);

  const loadCountries = useCallback(
    async (langCode: string) => {
      if (!countriesByKey.current[langCode] && !loading[langCode]) {
        setLoading((prev) => ({
          ...prev,
          [langCode]: true,
        }));
        const res = await axiosGeonamesClient.get('countryInfoJSON', {
          params: {
            username: `${process.env.REACT_APP_GEONAMES_USERNAME}`,
            token: `${process.env.REACT_APP_GEONAMES_USERNAME}`,
            lan: langCode,
          },
        });

        const formattedCountries = res?.data?.geonames.map((item: any) => ({
          label: item.countryName,
          value: item.countryCode,
        }));
        countriesByKey.current[langCode] = formattedCountries;
        setCountries(countriesByKey.current[langCode]);
        setLoading((prev) => ({
          ...prev,
          [langCode]: false,
        }));
      } else {
        setCountries(countriesByKey.current[langCode]);
      }
    },
    [loading],
  );

  const getCountryNameByCode = useCallback(
    (countryCode: string) => {
      return (
        countries?.find(
          (country) => country.value === countryCode.toUpperCase(),
        )?.label || ''
      );
    },
    [countries],
  );

  const getCountryNameByCodeAndLang = useCallback(
    (countryCode: string, lang: string) => {
      return (
        countriesByKey.current[lang]?.find(
          (country) => country.value === countryCode.toUpperCase(),
        )?.label || ''
      );
    },
    [countries],
  );

  return {
    countries,
    loadCountries,
    loading,
    getCountryNameByCode,
    getCountryNameByCodeAndLang,
  };
}
